import { feedbotToast } from '../../../../lib/feedbotToast'

export const toastNotifyIntentDescriptionSuggestionRecieveSuccess = () => {
  const id = 'suggestionRecieveSuccess'
  const title = 'New Suggested description generated'
  const content = 'We generated new Suggested intent description in opened modal.'

  feedbotToast.success({ id, title, content })
}
